import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {useDispatch } from "react-redux";
import { useSelector } from 'react-redux';
import HoverRightArrow from "web/assets/images/dropdown-menu-hover-arrow.png";

import './dropDownMenu.scss';

function DropDownMenu(props) {
  const cardExpiryDetails = useSelector(state => state.authReducer.cardExpiryDetails)
  let isSubscriptionCardExpired = cardExpiryDetails.subscriptionCardExpired
  const dispatch = useDispatch();
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const storedData = useSelector(
    (state) => state.storedData.payload
  );
  let disableFlg = storedData?.guestUser
  
  const pageLanguageContents = props.content
  let accountType = localStorage.getItem('formType')
  let MenuItems;
  let brokerAccount = localStorage.getItem('brokerAccount')
  if(disableFlg){
    MenuItems = [
      {
        title: pageLanguageContents?.Header[8]?.H8_Nav_Preference,
        //title: 'Manage Account',
        //path: '/manage-account?pageType=manageAccount',
        path: '/manage-account',
        cName: 'dropdown-link',
        type: 'manageAccount'
      }
    ];
  }
  else if (accountType === 'INDIVIDUAL' || accountType === 'CORPORATE_SUBACC') {
    MenuItems = [
      {
        title: pageLanguageContents?.Header[8]?.H8_Nav_Preference,
        //title: 'Manage Account',
        //path: '/manage-account?pageType=manageAccount',
        path: '/manage-account',
        cName: 'dropdown-link',
        type: 'manageAccount'
      },
      {
        title: brokerAccount === "brokerAc" ?
          pageLanguageContents?.Header[25]?.H8_Nav_Manage_Users
          :
          pageLanguageContents?.Header[7]?.H8_Nav_Manage,
        path: '/manage-users-and-locations',
        cName: isSubscriptionCardExpired ? 'dropdown-link event-li' : 'dropdown-link',
        type: 'manageLocations'
      }
    ];
  } else {
    MenuItems = [
      {
        title: pageLanguageContents?.Header[8]?.H8_Nav_Preference,
        //title: 'Manage Account',
        //path: '/manage-account?pageType=manageAccount',
        path: '/manage-account',
        cName: 'dropdown-link',
        type: 'manageAccount'
      },
      {
        title: brokerAccount === "brokerAc" ?
          pageLanguageContents?.Header[25]?.H8_Nav_Manage_Users
          :
          pageLanguageContents?.Header[7]?.H8_Nav_Manage,
        path: '/manage-users-and-locations',
        cName: isSubscriptionCardExpired ? 'dropdown-link event-li' : 'dropdown-link',
        type: 'manageLocations'
      }
    ];
  }

  const onLinkClick = (type) => {
    if (type === 'manageAccount') {
      let obj = {
        pageType: "manageAccount",
      }
      dispatch({ type: 'MANAGE_ACCOUNT', payload: obj })
    }
  };
  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? 'dropdown-menu1 clicked' : 'dropdown-menu1'}
      >
        {MenuItems.map((item, index) => {
          return (
            <li key={index}>
              <Link
                className={item.cName}
                to={item.path}
                onClick={() => onLinkClick(item.type)}
              >
                <img
                  className="arrow-image"
                  src={HoverRightArrow}
                  alt="right-arrow"
                />
                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropDownMenu;